import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const BackButtonWrapper = styled.span`
    margin-left: ${token('space.negative.200', '-16px')};
`;
